import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../authentications/authentication.service';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';

export const isNotAuthenticatedGuard: CanActivateFn = async (route, state) => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);

  const user = await firstValueFrom(authenticationService.currentUser$);

  const redirectUrl = route.queryParamMap.get('redirect');

  if (user) {
    if (redirectUrl && redirectUrl.startsWith('/') && redirectUrl !== '/sign-in') {
      router.navigateByUrl(redirectUrl);
    } else {
      router.navigateByUrl('/');
    }
    return false
  }
  return true;
};
